import { render } from "./berita.vue?vue&type=template&id=52b5198a"
import script from "./berita.vue?vue&type=script&lang=js"
export * from "./berita.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__